import { type operations } from "../generated/schema";
export { DataSyncValidationResponseStatus } from "../generated/schema";

export type DataSyncValidationApiResponse =
	operations["data_sync_validation"]["responses"]["200"]["content"]["application/json"];

export type DataSyncValidationGetRequestBody =
	operations["data_sync_validation"]["requestBody"]["content"]["application/json"];
